/**
 * Section impression names for /digital-wedding-invitation.
 *
 * Same reasoning as `wedding-photo-sharing/sections.js`: `trackSectionViewed`
 * is section-name-agnostic, but the shared analytics module documents its
 * supported values as a closed set with a named wrapper per value, and that
 * module is vendored byte-identical into invite/ and app/ (guarded by
 * `npm run verify:analytics`). Adding page-specific wrappers there would mean
 * editing two other apps to instrument a landing-page section, so page-local
 * constants keep the "one owner per string, never a literal at a call site"
 * rule without that blast radius.
 *
 * Five impressions, not eleven: the guest flow, the differentiator the page is
 * really selling, the sample-invitation offer, the plan qualifier and the
 * close. Enough to see where a search visitor stops, without turning the funnel
 * report into noise.
 *
 * The sample-invitation section deliberately reuses the EXISTING
 * `invitation_preview` section name (see `trackInvitationPreviewViewed` in
 * lib/analytics/events.js) rather than minting a new one — the homepage
 * pricing card already reports that name for the same offer, and one name for
 * one thing is what makes the two comparable.
 */
export const DWI_SECTION = {
  STEPS: "digital_wedding_invitation_steps",
  RSVP: "digital_wedding_invitation_rsvp",
  ARC: "digital_wedding_invitation_arc",
  PLAN: "digital_wedding_invitation_plan",
  FAQ: "digital_wedding_invitation_faq",
  FINAL_CTA: "digital_wedding_invitation_final_cta",
};

export default DWI_SECTION;
